import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../../../auth/infrastructure/slices/authSlice';
import type { UserProfile } from '../../application/types';
import { userProfileApi } from '../api/user.api';

export type UserProfileState = {
  profile: UserProfile | null;
};

const initialState: UserProfileState = {
  profile: null,
};

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(logout, state => {
        state.profile = null;
      })
      .addMatcher(
        userProfileApi.endpoints.getProfile.matchFulfilled,
        (state, { payload }) => {
          state.profile = payload;
        },
      );
  },
});

export default userProfileSlice.reducer;
